import { useMutation } from '@tanstack/react-query';
import { APIAuth } from 'lib/api/firebase/apis/api-auth';

export const useUpdateProfile = () => {
  return useMutation({
    mutationFn: (variables: { email?: string; displayName?: string }) =>
      APIAuth.updateProfile(variables)
  });
};
